type RawSupplierAttribute = {
    Name: string;
    Value: string;
};

type RawSupplierValue = {
    Attributes: RawSupplierAttribute[];
};

export class Supplier {
    email: string;
    companyName: string;
    supplierID: string;
    swordsVN: string;
    flandersVN: string;
    llanberisVN: string;
    lasAngelesVN: string;

    static jsonToSuppliers(supplierJson: unknown[]): Supplier[] {
        const arr: Supplier[] = [];
        if (supplierJson) {
            supplierJson.forEach((rawValue) => {
                const value = rawValue as RawSupplierValue;
                const newSupplier = new Supplier();
                value.Attributes.forEach((attribute) => {
                    switch (attribute.Name) {
                        case 'email':
                            newSupplier.email = attribute.Value;
                            break;
                        case 'custom:CompanyName':
                            newSupplier.companyName = attribute.Value;
                            break;
                        case 'custom:SiemensSupplierID':
                            newSupplier.supplierID = attribute.Value;
                            break;
                        case 'custom:SwordsVendorNumber':
                            newSupplier.swordsVN = attribute.Value;
                            break;
                        case 'custom:FlandersVendorNumber':
                            newSupplier.flandersVN = attribute.Value;
                            break;
                        case 'custom:LlanbVendorNumber':
                            newSupplier.llanberisVN = attribute.Value;
                            break;
                        case 'custom:LAVendorNumber':
                            newSupplier.lasAngelesVN = attribute.Value;
                            break;
                    }
                });
                arr.push(newSupplier);
            });
        }
        return arr;
    }
}
